import type { PayloadAction } from '@reduxjs/toolkit';
import type { ResolvedEmailBlock } from '@/micros/edit-project/grid-areas/main/campaigns/templates/widgets/block-types';
import type { CampaignEditorReducerCreator } from '../types';

// a widget dropped onto the preview - after the block it was dropped on, or at the end
const insertBlock = (create: CampaignEditorReducerCreator) =>
  create.reducer((state, action: PayloadAction<{ block: ResolvedEmailBlock; afterId?: string }>) => {
    const { block, afterId } = action.payload;
    const current = state.blocks ?? [];
    const afterIndex = afterId ? current.findIndex((b) => b.id === afterId) : -1;
    state.blocks =
      afterIndex === -1
        ? [...current, block]
        : [...current.slice(0, afterIndex + 1), block, ...current.slice(afterIndex + 1)];
  });

export default insertBlock;
